import { IShoppingCartV3 } from "interfaces/session/ShoppingCart";
import { IRefreshShoppingCartStateAction } from "../interfaces/shopping-cart.interface";

export function refeshShoppingCartState(data: IShoppingCartV3): IRefreshShoppingCartStateAction {
  return {
    type: "REFRESH_SHOPPING_CART",
    data,
  };
}
